<div class="max-auto plMd prMd">
    <h2 class="h2 text-dark sa-article-heading mb20">{{ text }}</h2>
</div>